export default __webpack_public_path__ + "static/homepage-coffee-pour-e7a806591ff72391ea105bdef589b340.png";